
const ThemeSuspense = () => {

  const academiaLogo = localStorage.getItem('academiaLogo')

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-900">
  <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black/20 backdrop-blur-md">
            <img
              src={
                !academiaLogo || academiaLogo === "null"
                  ? "/academiusLogoFinal.svg"
                  : academiaLogo
              }
              className="w-24 h-24 animate-spin"
              style={{
                opacity: 0.60,
                filter: "drop-shadow(0 0 20px rgba(255,255,255,0.2))"
              }}
            />
          </div>

    </div>
  );
};

export default ThemeSuspense;
